import { FC, useEffect } from "react"
import { CompetitionHeadVoteBlockDescription, CompetitionHeadVoteBlockTitle, CompetitionHeadVoteBlockWrapper, CompetitionTextAreaContainer } from "./styles"
import { useTranslation } from "react-i18next"
import { CommonInput, INPUT_TYPES } from "@brg/ui"
import { useVoteContest } from "core/providers/VoteProvider"
import setTextByLang from "shared/helpers/setTextByLang"
import { LangObject } from "shared/pages/CourseEdit/types"

type Props = {
    readOnly?: boolean;
    comment?: LangObject[];
};

export const CompetitionHeadVoteBlock: FC<Props> = ({ readOnly = false, comment }) => {
    const { t, i18n } = useTranslation()
    const { headText, setHeadText } = useVoteContest()

    useEffect(() => {
        if (comment?.length) {
            setHeadText(comment);
        }
    }, [comment]);

    return (
        <CompetitionHeadVoteBlockWrapper>
            <CompetitionHeadVoteBlockTitle>{t('project.head_block.title')}</CompetitionHeadVoteBlockTitle>
            <CompetitionHeadVoteBlockDescription>{t('project.head_block.description')}</CompetitionHeadVoteBlockDescription>
            <CompetitionTextAreaContainer>
                <CommonInput
                    type={INPUT_TYPES.textarea}
                    orientation={'column'}
                    label={t('project.head_block.label')}
                    placeholder={t('project.head_block.placeholder')}
                    useLangSwitcher
                    onChange={(ev: any, lang?: string) => {
                        if (readOnly) return;
                        setHeadText(
                            setTextByLang(
                                headText,
                                lang ?? i18n.language,
                                ev?.target?.value ?? ''
                            )
                        );
                    }}
                    value={headText}
                    minHeight={133}
                    maxLength={1000}
                    disable={readOnly}
                />
            </CompetitionTextAreaContainer>
        </CompetitionHeadVoteBlockWrapper>
    )
}
import { FC, useEffect } from "react"
import { CompetitionHeadVoteBlockDescription, CompetitionHeadVoteBlockTitle, CompetitionHeadVoteBlockWrapper, CompetitionTextAreaContainer } from "./styles"
import { useTranslation } from "react-i18next"
import { CommonInput, INPUT_TYPES } from "@brg/ui"
import { useVoteContest } from "core/providers/VoteProvider"
import setTextByLang from "shared/helpers/setTextByLang"
import { LangObject } from "shared/pages/CourseEdit/types"

type Props = {
    readOnly?: boolean;
    comment?: LangObject[];
};

export const CompetitionHeadVoteBlock: FC<Props> = ({ readOnly = false, comment }) => {
    const { t, i18n } = useTranslation()
    const { headText, setHeadText } = useVoteContest()

    useEffect(() => {
        if (comment?.length) {
            setHeadText(comment);
        }
    }, [comment]);

    return (
        <CompetitionHeadVoteBlockWrapper>
            <CompetitionHeadVoteBlockTitle>{t('project.head_block.title')}</CompetitionHeadVoteBlockTitle>
            <CompetitionHeadVoteBlockDescription>{t('project.head_block.description')}</CompetitionHeadVoteBlockDescription>
            <CompetitionTextAreaContainer>
                <CommonInput
                    type={INPUT_TYPES.textarea}
                    orientation={'column'}
                    label={t('project.head_block.label')}
                    placeholder={t('project.head_block.placeholder')}
                    useLangSwitcher
                    onChange={(ev: any, lang?: string) => {
                        if (readOnly) return;
                        setHeadText(
                            setTextByLang(
                                headText,
                                lang ?? i18n.language,
                                ev?.target?.value ?? ''
                            )
                        );
                    }}
                    value={headText}
                    minHeight={133}
                    maxLength={1000}
                    disable={readOnly}
                />
            </CompetitionTextAreaContainer>
        </CompetitionHeadVoteBlockWrapper>
    )
}
